export default "__VITE_ASSET__BLi0ZVhb__"